
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './principal.scss';






const Pprincipal = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id689d69b460a29c1eab0f96cc" >

      <div id="ig5a" className="">
      
      <div id="ip1o" className="gjs-row ">
      
      <div id="ibmh" className="gjs-cell ">
      
      <img
        className=""
        id="ig2u"
        src="https://assetsprojects.s3.amazonaws.com/404pziimeax27lc.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="inlm" className="gjs-cell ">
      
        <a
          target=""
          className=""
          id="iy3g"
          href="#"
        >
          
    <div id="iarm" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipwy4"
          href="#i12x2i"
        >
          
    <div id="irw8k" className="">
    <>Qué es</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivwb3"
          href="#ibt05h"
        >
          
    <div id="ixufq" className="">
    <>Como funciona</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ip1e9w"
          href="https://hackathon.sustentahonduras.org/"
        >
          
    <div id="ih4uek" className="">
    <>Hackathon</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iy2r" className="gjs-cell ">
      
        <a
          target=""
          className=""
          id="i6l0n"
          href="https://wa.me/50431938407"
        >
          
    <div id="icwrm" className="">
    <>Envía un mensaje</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="io5tr" className="">
      
      <div id="iw2bc" className="gjs-row ">
      
      <div id="inckj" className="gjs-cell ">
      
      <div className="" id="iy1yi">
        <>Tu asistente electoral en Honduras</>
      </div>
      
      <div className="" id="ie0if">
        <>Resuelve todas tus dudas sobre el proceso electoral de forma rápida, clara y confiable.</>
      </div>
      
        <a
          target=""
          className=""
          id="in4a5"
          href="https://wa.me/50431938407"
        >
          
    <div id="iviox" className="">
    <>Chatea</>
    </div>
    
        </a>
        
      </div>
      
      <div id="ixz7f" className="gjs-cell ">
      
      <img
        className=""
        id="iwese"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfuo2w9o.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i12x2i" className="">
      
      <div id="ifxhv" className="gjs-row ">
      
      <div id="i5xjri" className="gjs-cell ">
      
      <img
        className=""
        id="i4ex2w"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfuoa7e2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i0oqn" className="gjs-cell ">
      
      <div className="" id="i6o1sc">
        <>¿Qué es Chat CNE?</>
      </div>
      
      <div className="" id="i6whgx">
        <>Chat CNE es un chatbot inteligente desarrollado para responder tus preguntas sobre el proceso electoral en Honduras. Desde cómo y dónde votar, hasta información sobre requisitos, calendario electoral, papeletas y resultados. Todo en un solo lugar, sin largas búsquedas.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i9guz" className="">
      
      <div className="" id="i8isw">
        <>¿Qué puedo preguntar?</>
      </div>
      
      <div className="" id="i34nr">
        <>Puedes consultar sobre</>
      </div>
      
      <div id="iy3fx" className="">
      
      <div id="ix349" className="">
      
      <img
        className=""
        id="ix35k"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfuov4cd.png"
        alt="undefined"
      />
      
      <div className="" id="ij9y9">
        <>Fechas importantes</>
      </div>
      
      <div className="" id="iabpf">
        <>Inscripciones, elecciones, entrega de credenciales.</>
      </div>
      
      </div>
      
      <div id="ii2r02" className="">
      
      <img
        className=""
        id="ihxvk8"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfup1eyr.png"
        alt="undefined"
      />
      
      <div className="" id="i0fmgh">
        <>Proceso electoral</>
      </div>
      
      <div className="" id="iqklbh">
        <>Cómo funciona la votación paso a paso.</>
      </div>
      
      </div>
      
      <div id="i277ib" className="">
      
      <img
        className=""
        id="i9pa8"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfuov4cd.png"
        alt="undefined"
      />
      
      <div className="" id="izn47">
        <>Requisitos</>
      </div>
      
      <div className="" id="ix9a5a">
        <>Qué necesitas para ejercer tu voto.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="bloqueporque" className="">
      
      <div id="i8j7oz" className="gjs-row ">
      
      <div id="i5w65" className="gjs-cell ">
      
      <img
        className=""
        id="ip09n"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfup3ahi.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i5f24" className="gjs-cell ">
      
      <div className="" id="i0nou">
        <>Beneficios</>
      </div>
      
      <div id="ixosz" className="gjs-row ">
      
      <div id="i3azz" className="gjs-cell ">
      
      <img
        className=""
        id="i8ejk"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfup7gus.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ifrno" className="gjs-cell ">
      
      <div className="" id="ivcus">
        <>Disponible 24/7</>
      </div>
      
      <div className="" id="ie5hyq">
        <>Responde en cualquier momento.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iae5nt" className="gjs-row ">
      
      <div id="i12tkj" className="gjs-cell ">
      
      <img
        className=""
        id="ikwf2h"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfup7gus.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="io8o1z" className="gjs-cell ">
      
      <div className="" id="i8fel6">
        <>Información oficial y confiable</>
      </div>
      
      <div className="" id="i8dmmk">
        <>del Consejo Nacional Electoral.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="im4lsm" className="gjs-row ">
      
      <div id="iro15n" className="gjs-cell ">
      
      <img
        className=""
        id="ia2vml"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfup7gus.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i9ii4u" className="gjs-cell ">
      
      <div className="" id="ia3nuv">
        <>Interacción natural:</>
      </div>
      
      <div className="" id="izhnck">
        <>escribe tus dudas como si hablaras con una persona.</>
      </div>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="irxyk"
          href="https://wa.me/50431938407"
        >
          
    <div id="issop" className="">
    <>Consulta Gratuita</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ibt05h" className="">
      
      <div id="idw15h" className="gjs-row ">
      
      <div id="ixqbcw" className="gjs-cell ">
      
      <div className="" id="iqe34k">
        <>Cómo funciona</>
      </div>
      
      <div className="" id="in876j">
        <>1. Ingresa al chat desde el botón de la página.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>2. Escribe tu pregunta sobre las elecciones.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>3. Recibe una respuesta inmediata con información clara y oficial.</>
      </div>
      
      </div>
      
      <div id="ijamyi" className="gjs-cell ">
      
      <img
        className=""
        id="ixjcyr"
        src="https://assetsprojects.s3.amazonaws.com/404no3ilfupkdqj.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ifwldj" className="">
      
      <div className="" id="iozx9e">
        <>Chat CNE nace como uno de los diez proyectos ganadores del Hackathon de Transparencia Electoral, organizado por Sustenta Honduras en colaboración con la Universidad Tecnológica Centroamericana (UNITEC), campus San Pedro Sula. Este evento se llevó a cabo en el marco de los Subsidios de Bajo Valor del proyecto EUROELECT-H, financiado por la Unión Europea y con implementación técnica del Programa de las Naciones Unidas para el Desarrollo (PNUD) en Honduras.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Esta plataforma fue desarrollada con el objetivo de fortalecer la democracia en Honduras mediante herramientas tecnológicas innovadoras que promuevan la transparencia electoral y la participación ciudadana.</>
      </div>
      
      <div id="irgpoj" className="">
      
        <a
          target=""
          className=""
          id="i6htvf"
          href="https://wa.me/50431938407"
        >
          
    <div id="i8isa6" className="">
    <>Charlemos</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i92snh" className="">
      
      <img
        className=""
        id="i55ksz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhxyzbqo.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i0l0rv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhxyy3zj.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ihtsof"
        src="https://assetsprojects.s3.amazonaws.com/404pziimexrndi1.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="isr7q9">
        <>Autores de la Idea</>
      </div>
      
      <div className="" id="ib7xe3">
        <>Carles Joseph Nuñez Gutierrez</>
      <br className="" id="" />
      <>Moises Elias Ceballos Ruiz</>
      <br className="" id="" />
      <>David Alfredo Lopez Duarte</>
      <br className="" id="" />
      <>Dylan Fabricio Banegas Dubón</>
      </div>
      
      </div>
      
      <div id="ijicjt" className="">
      
      <div id="imq453" className="">
      
      <div id="ic82rj" className="">
      
      <img
        className=""
        id="iouaz9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimeaxegvz.png"
        alt="undefined"
      />
      
      <div className="" id="ilndz6">
        <>Tu asistente electoral en Honduras, disponible 24/7</>
      <br className="" id="" />
      <>Resuelve todas tus dudas sobre el proceso electoral de forma rápida, clara y confiable.</>
      </div>
      
      </div>
      
      <div id="i9dgde" className="">
      
      <div className="" id="i1vfwf">
        <>Si deseas contactarte con nosotros o contribuir al desarrollo de este proyecto, puedes escribir a info@sustentahonduras.org</>
      </div>
      
      <img
        className=""
        id="iisi4s"
        src="https://assetsprojects.s3.amazonaws.com/404pziimexrndi1.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pprincipal);
  